import React, { useState } from "react";
import FabIcon from "assets/icons/Fab.svg";
import Popover from "@material-ui/core/Popover";
import SubmitTrailProblem from "components/SubmitTrailProblem";
import { makeStyles } from "@material-ui/core/styles";

const Fab = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [submitTrailProblemModalOpen, setSubmitTrailProblemModalOpen] =
    useState(false);

  const useStyles = makeStyles((theme) => ({
    popoverPaper: {
      backgroundColor: "#ffffff",
    },
    cancel: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      /* identical to box height, or 143% */
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      letterSpacing: "0.25px",
      padding: "7px",
      color: "red",
      cursor: "pointer",
      "&:hover, &:focus": {
        backgroundColor: "#E0E0E0",
      },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      width: "220px",
      alignContent: "center",
    },
    link: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: "20px",
      /* identical to box height, or 143% */
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      letterSpacing: "0.25px",
      padding: "7px",
      cursor: "pointer",
      "&:hover, &:focus": {
        backgroundColor: "#E0E0E0",
      },
      whiteSpace: "break-spaces",
    },
  }));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "fab-popover" : undefined;
  const classes = useStyles();

  const goToSurvey = () => {
    window.open(
      "https://survey123.arcgis.com/share/e911c01e84194de28660d82663f8c6f5",
      "_blank"
    );
  };

  const handleSubmitTrailProblemModalOpen = () => {
    setSubmitTrailProblemModalOpen(true);
  };

  const handleSubmitTrailProblemModalClose = () => {
    setSubmitTrailProblemModalOpen(false);
  };

  return (
    <>
      <img src={FabIcon} alt="Fab Icon" onClick={handleClick} />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={{ paper: classes.popoverPaper }}
      >
        <div class={classes.container}>
          <div class={classes.link} onClick={handleSubmitTrailProblemModalOpen}>
            Report a Trail Problem
          </div>
          <div
            class={classes.link}
            onClick={() => {
              goToSurvey();
            }}
          >
            Provide DE<span style={{ fontWeight: "bold" }}>TOUR</span> Feedback
          </div>
          <div class={classes.cancel} onClick={handleClose}>
            Cancel
          </div>
        </div>
      </Popover>
      <SubmitTrailProblem
        submitTrailProblemOpen={submitTrailProblemModalOpen}
        setSubmitTrailProblemClose={handleSubmitTrailProblemModalClose}
      />
    </>
  );
};

export default Fab;
